<template>
  <div class="footer">
    <img src="../assets/navbar/lines.png" alt="lines icon" @click="nav('/locked/true')" />
    <img src="../assets/navbar/circle.png" alt="circle icon" @click="nav('/home')" />
    <img src="../assets/navbar/triangle.png" alt="triangle icon" @click="nav('/')" />
  </div>
</template>

<script>
export default {
  methods: {
    back() {
      this.$router.go(-1);
    },
    nav(dest) {
      this.$router.push({ path: `${dest}` });
    }
  }
};
</script>

<style lang="scss" scoped>
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  background-color: #000;
  z-index: 50;

  img {
    width: 20px;
    height: 20px;
  }
}

img:hover {
  cursor: pointer;
}
</style>
